import { ROUTES } from 'constants/routes';

import { appAuth } from '../../firebase';
import { activeGameCode } from '../../active-game';
import { moveToRoute } from '../../utils';

export const requireActiveGameCode = (callableName: string): string => {
  const gameCode = activeGameCode.get();
  if (gameCode) {
    return gameCode;
  }

  if (appAuth.currentUser) {
    moveToRoute(ROUTES.joinGame);
  }
  throw new Error(`No active gameCode for callable "${callableName}"`);
};
